// extracted by mini-css-extract-plugin
export default {"spinning_loader_container":"spinning-loader_spinning_loader_container__hE+Zr"};